/**
 * Open/canceled order rows expose `takenby` as www_users.userid, while salesperson pickers
 * use salesman.salesmancode. Match either `details.salesperson` or takenby→salesman.username.
 */
export function orderMatchesSalespeopleFilter(
	order: { takenby?: unknown; details?: { salesperson?: unknown; takenby?: unknown } },
	selectedCodes: unknown[],
	salespeopleRows: { salesmancode?: unknown; username?: unknown; linked_userids?: unknown }[]
): boolean {
	const normalizedSelected = selectedCodes
		.map((c) => (c != null && c !== '' ? String(c).trim() : ''))
		.filter((c) => c !== '');
	if (normalizedSelected.length === 0) {
		return true;
	}

	const details = order?.details ?? {};
	const spOnOrder = (details.salesperson != null ? String(details.salesperson) : '').trim();
	const takenBy = String(order?.takenby ?? details.takenby ?? '').trim();

	for (const code of normalizedSelected) {
		if (spOnOrder !== '' && spOnOrder === code) {
			return true;
		}
		if (spOnOrder === '' && takenBy !== '') {
			const row = salespeopleRows.find((p) => String(p?.salesmancode ?? '').trim() === code);
			if (row) {
				if (String(row.username ?? '').trim() === takenBy) {
					return true;
				}
				const linked = String(row.linked_userids ?? '')
					.split(',')
					.map((s) => s.trim())
					.filter(Boolean);
				if (linked.includes(takenBy)) {
					return true;
				}
			}
		}
	}
	return false;
}
